export enum FilePreviewAccessEnum {
  /**Доступ на редактирование */
  Edit = "edit",
  /**Доступ на удаления файла */
  Remove = "remove"
}
